<template>
  <div
    id="euler"
    @click="clickOutside"
    :class="{ 'youmi-en': isYOUMIEN, 'youmi-offers': isOFFERSYOUMI }"
  >
    <layout ref="layout"></layout>
  </div>
</template>

<script>
import layout from './layout.vue'

export default {
  computed: {
    isYOUMIEN() {
      return this.source === 'youmi-en'
    },
    isOFFERSYOUMI() {
      return this.source === 'youmi-offers'
    },
  },
  props: {
    source: {
      type: String,
      default: '',
    },
    prefix: {
      type: String,
    },
    baseurl: {
      type: String,
    },
  },
  methods: {
    clickOutside() {
      this.$refs.layout.clickOutside()
    },
  },
  components: {
    layout,
  },
}
</script>

<style scoped>
#euler {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-size: 12px;
  color: #606266;
  background: #fff;
  height: 100%;
  width: 100%;
}

#euler h1 {
  font-size: 40px;
  font-weight: 500;
}
</style>
